const changeModalBody = function(actionData, dataId) {
    const modal = document.querySelector(`#modal-special-call`); 
    const modalBody = modal.querySelector(`.modal__left_content`);
    
    if (actionData['status'] === 'error') {
        modalBody.innerHTML = actionData['default']['text'];
        throw `Request content for spec action data-target: ${dataId}. ${actionData['message']}`;
    };
    modalBody.innerHTML = actionData;
}

const getSpecialContent = function(dataId) {
    
    try {
        fetch('/_file/info/service/special-offers-popup-handler.php?'  + new URLSearchParams({
            'actionId': dataId,
        })).then(res => res.json())
           .then(json => {
                return json; 
            })
           .then(body => changeModalBody(body, dataId))
    } catch (err) {
         console.log(err);
    }  
}

const services = document.querySelector(`.special__body`);

if (services) {
    services.addEventListener(`click`, (evt) => {
        const target = evt.target;

        if (target.closest(`.js-popup-link`)) {
            const service = target.closest(`.js-popup-link`);
            const actionData = service.dataset.target.split('-').slice(1).join(`-`);
            getSpecialContent(actionData);          
        }   
    })
}
